import React, { useEffect, useState } from 'react';
import { XIcon, MapPinIcon, SearchIcon, PackageIcon, StoreIcon, NavigationIcon, PencilIcon, TrashIcon, ChevronRightIcon, HomeIcon, BriefcaseIcon, MapIcon, ArrowLeftIcon } from 'lucide-react';
interface LocationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectLocation: (location: any) => void;
  initialAddress?: {
    city?: string;
    district?: string;
    street?: string;
    additionalDetails?: string;
    nationalAddressId?: string;
  };
}
type Step = 'main' | 'currentLocation' | 'manual' | 'national';
export function LocationModal({
  isOpen,
  onClose,
  onSelectLocation,
  initialAddress
}: LocationModalProps) {
  const [deliveryType, setDeliveryType] = useState<'delivery' | 'pickup'>('delivery');
  const [step, setStep] = useState<Step>('main');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedAddress, setSelectedAddress] = useState<any>(null);
  const [selectedPickupBranch, setSelectedPickupBranch] = useState<any>(null);
  const [pickupCity, setPickupCity] = useState('');
  const [pickupDistrict, setPickupDistrict] = useState('');
  const [showNearest, setShowNearest] = useState(false);
  const [isNowCoverageUnavailable, setIsNowCoverageUnavailable] = useState(false);
  const [gpsAddress, setGpsAddress] = useState('2214 Prince Mohammed Bin Salman Rd, Al Yasmin, Riyadh, Saudi Arabia');
  const detectedLocation = {
    lat: 24.7136,
    lng: 46.6753
  };
  const [manualCity, setManualCity] = useState('');
  const [manualDistrict, setManualDistrict] = useState('');
  const [manualDetails, setManualDetails] = useState('');
  const [nationalAddressId, setNationalAddressId] = useState('');
  const [nationalAddressDetails, setNationalAddressDetails] = useState<any>(null);
  const [savedAddresses, setSavedAddresses] = useState([{
    id: 1,
    name: 'Home',
    address: '2214 Prince Mohammed Bin Salman Rd, Al Yasmin, Riyadh, Saudi Arabia',
    type: 'home',
    icon: HomeIcon
  }, {
    id: 2,
    name: 'Work',
    address: '1234 King Fahd Rd, Al Olaya, Riyadh, Saudi Arabia',
    type: 'work',
    icon: BriefcaseIcon
  }]);
  const allPharmacyBranches = [{
    id: 1,
    name: 'Innova Pharmacy - Riyadh Park',
    address: 'Riyadh Park Mall, Al Malaz, Riyadh',
    city: 'Riyadh',
    district: 'Al Malaz',
    distance: 2.5,
    hours: 'Open until 11:00 PM',
    status: 'open'
  }, {
    id: 2,
    name: 'Innova Pharmacy - Kingdom Centre',
    address: 'Kingdom Centre, Al Olaya, Riyadh',
    city: 'Riyadh',
    district: 'Al Olaya',
    distance: 3.2,
    hours: 'Open 24 hours',
    status: 'open'
  }, {
    id: 3,
    name: 'Innova Pharmacy - Al Nakheel',
    address: 'Al Nakheel District, Riyadh',
    city: 'Riyadh',
    district: 'Al Nakheel',
    distance: 4.1,
    hours: 'Open until 10:00 PM',
    status: 'open'
  }, {
    id: 4,
    name: 'Innova Pharmacy - Al Yasmin',
    address: 'Prince Mohammed Bin Salman Rd, Al Yasmin, Riyadh',
    city: 'Riyadh',
    district: 'Al Yasmin',
    distance: 1.8,
    hours: 'Open until 12:00 AM',
    status: 'open'
  }, {
    id: 5,
    name: 'Innova Pharmacy - Red Sea Mall',
    address: 'Red Sea Mall, Al Rawdah, Jeddah',
    city: 'Jeddah',
    district: 'Al Rawdah',
    distance: 3.5,
    hours: 'Open until 11:00 PM',
    status: 'open'
  }, {
    id: 6,
    name: 'Innova Pharmacy - Corniche',
    address: 'Corniche Road, Al Salama, Jeddah',
    city: 'Jeddah',
    district: 'Al Salama',
    distance: 5.2,
    hours: 'Open 24 hours',
    status: 'open'
  }, {
    id: 7,
    name: 'Innova Pharmacy - Al Zahra',
    address: 'Al Zahra District, Jeddah',
    city: 'Jeddah',
    district: 'Al Zahra',
    distance: 2.8,
    hours: 'Open until 10:00 PM',
    status: 'open'
  }, {
    id: 8,
    name: 'Innova Pharmacy - Al Nahda',
    address: 'Al Nahda District, Jeddah',
    city: 'Jeddah',
    district: 'Al Nahda',
    distance: 4.3,
    hours: 'Open until 11:30 PM',
    status: 'open'
  }, {
    id: 9,
    name: 'Innova Pharmacy - Al Aziziyah',
    address: 'Al Aziziyah District, Makkah',
    city: 'Makkah',
    district: 'Al Aziziyah',
    distance: 2.1,
    hours: 'Open 24 hours',
    status: 'open'
  }, {
    id: 10,
    name: 'Innova Pharmacy - Al Shawqiyah',
    address: 'Al Shawqiyah District, Makkah',
    city: 'Makkah',
    district: 'Al Shawqiyah',
    distance: 3.7,
    hours: 'Open until 11:00 PM',
    status: 'open'
  }, {
    id: 11,
    name: 'Innova Pharmacy - Al Khalidiyyah',
    address: 'Al Khalidiyyah District, Madinah',
    city: 'Madinah',
    district: 'Al Khalidiyyah',
    distance: 1.9,
    hours: 'Open 24 hours',
    status: 'open'
  }, {
    id: 12,
    name: 'Innova Pharmacy - Quba',
    address: 'Quba District, Madinah',
    city: 'Madinah',
    district: 'Quba',
    distance: 4.5,
    hours: 'Open until 10:00 PM',
    status: 'open'
  }, {
    id: 13,
    name: 'Innova Pharmacy - Al Faisaliyah',
    address: 'Al Faisaliyah District, Dammam',
    city: 'Dammam',
    district: 'Al Faisaliyah',
    distance: 2.3,
    hours: 'Open until 11:00 PM',
    status: 'open'
  }, {
    id: 14,
    name: 'Innova Pharmacy - Al Shati',
    address: 'Al Shati District, Dammam',
    city: 'Dammam',
    district: 'Al Shati',
    distance: 3.8,
    hours: 'Open 24 hours',
    status: 'open'
  }, {
    id: 15,
    name: 'Innova Pharmacy - Al Corniche',
    address: 'Al Corniche District, Khobar',
    city: 'Khobar',
    district: 'Al Corniche',
    distance: 1.5,
    hours: 'Open until 12:00 AM',
    status: 'open'
  }, {
    id: 16,
    name: 'Innova Pharmacy - Al Aqrabiyah',
    address: 'Al Aqrabiyah District, Khobar',
    city: 'Khobar',
    district: 'Al Aqrabiyah',
    distance: 3.1,
    hours: 'Open until 11:00 PM',
    status: 'open'
  }];
  const cities = [{
    id: 'riyadh',
    name: 'Riyadh'
  }, {
    id: 'jeddah',
    name: 'Jeddah'
  }, {
    id: 'makkah',
    name: 'Makkah'
  }, {
    id: 'madinah',
    name: 'Madinah'
  }, {
    id: 'dammam',
    name: 'Dammam'
  }, {
    id: 'khobar',
    name: 'Khobar'
  }];
  const districtsByCity = {
    riyadh: ['Al Olaya', 'Al Malaz', 'Al Nakheel', 'Al Yasmin'],
    jeddah: ['Al Rawdah', 'Al Salama', 'Al Zahra', 'Al Nahda'],
    makkah: ['Al Aziziyah', 'Al Shawqiyah', 'Al Hindawiyah', 'Jarwal'],
    madinah: ['Al Khalidiyyah', 'Al Uyun', 'Al Iskan', 'Quba'],
    dammam: ['Al Faisaliyah', 'Al Shati', 'Al Adamah', 'Al Noor'],
    khobar: ['Al Corniche', 'Al Aqrabiyah', 'Al Thuqbah', 'Al Hizam']
  };
  const getFilteredBranches = () => {
    let filtered = [...allPharmacyBranches];
    if (pickupCity) {
      const cityName = cities.find(c => c.id === pickupCity)?.name;
      filtered = filtered.filter(branch => branch.city === cityName);
    }
    if (pickupDistrict) {
      filtered = filtered.filter(branch => branch.district === pickupDistrict);
    }
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(branch => branch.name.toLowerCase().includes(query) || branch.address.toLowerCase().includes(query) || branch.city.toLowerCase().includes(query) || branch.district.toLowerCase().includes(query));
    }
    if (showNearest) {
      filtered.sort((a, b) => a.distance - b.distance);
    }
    return filtered;
  };
  const handleNavigateToStep = (newStep: Step) => {
    setStep(newStep);
  };
  const handleBackToMain = () => {
    setStep('main');
  };
  const handleSaveGPSLocation = () => {
    const newAddress = {
      id: Date.now(),
      name: 'Current Location',
      address: gpsAddress,
      type: 'current',
      icon: NavigationIcon
    };
    setSavedAddresses([...savedAddresses, newAddress]);
    setSelectedAddress(newAddress);
    setStep('main');
  };
  const handleSaveManualAddress = () => {
    if (!manualCity || !manualDistrict || !manualDetails) {
      alert('Please fill in all fields');
      return;
    }
    const cityName = cities.find(c => c.id === manualCity)?.name || manualCity;
    const fullAddress = `${manualDetails}, ${manualDistrict}, ${cityName}, Saudi Arabia`;
    const newAddress = {
      id: Date.now(),
      name: 'Custom Address',
      address: fullAddress,
      type: 'custom',
      icon: MapPinIcon
    };
    setSavedAddresses([...savedAddresses, newAddress]);
    setSelectedAddress(newAddress);
    setManualCity('');
    setManualDistrict('');
    setManualDetails('');
    setStep('main');
  };
  const handleGetNationalAddress = () => {
    if (!nationalAddressId) {
      alert('Please enter a National Address ID');
      return;
    }
    setNationalAddressDetails({
      city: 'Riyadh',
      district: 'Al Yasmin',
      street: 'Prince Mohammed Bin Salman Rd',
      buildingNo: '2214',
      postalCode: '13325',
      additionalInfo: 'Villa 4'
    });
  };
  const handleSaveNationalAddress = () => {
    if (!nationalAddressDetails) return;
    const fullAddress = `${nationalAddressDetails.buildingNo} ${nationalAddressDetails.street}, ${nationalAddressDetails.district}, ${nationalAddressDetails.city}, Saudi Arabia`;
    const newAddress = {
      id: Date.now(),
      name: 'National Address',
      address: fullAddress,
      type: 'national',
      icon: MapIcon
    };
    setSavedAddresses([...savedAddresses, newAddress]);
    setSelectedAddress(newAddress);
    setNationalAddressId('');
    setNationalAddressDetails(null);
    setStep('main');
  };
  const handleRemoveAddress = (id: number) => {
    setSavedAddresses(savedAddresses.filter(addr => addr.id !== id));
    if (selectedAddress?.id === id) {
      setSelectedAddress(null);
    }
  };
  const handleEditAddress = (address: any) => {
    const newName = prompt('Enter new name for this address:', address.name);
    if (newName) {
      setSavedAddresses(savedAddresses.map(addr => addr.id === address.id ? {
        ...addr,
        name: newName
      } : addr));
    }
  };
  const handleConfirmAddress = () => {
    if (!selectedAddress) {
      alert('Please select a delivery address');
      return;
    }
    if (!selectedAddress.address.toLowerCase().includes('riyadh')) {
      setIsNowCoverageUnavailable(true);
      return;
    }
    onSelectLocation({
      ...selectedAddress,
      type: 'delivery'
    });
    onClose();
  };
  const continueWithStandardDelivery = () => {
    if (!selectedAddress) return;
    onSelectLocation({
      ...selectedAddress,
      type: 'delivery',
      nowEligible: false
    });
    setIsNowCoverageUnavailable(false);
    onClose();
  };
  const handleClose = () => {
    setStep('main');
    onClose();
  };
  const ModalHeader = ({
    title,
    showBack = false
  }: {
    title: string;
    showBack?: boolean;
  }) => <div className="bg-[#0066CC] p-4 text-white flex items-center justify-between flex-shrink-0" data-id="element-3714" data-mp="3pj8opcnjdj3j">
      <div className="flex items-center flex-1" data-id="element-3715" data-mp="3uibuizbcbtck">
        {showBack && <button onClick={handleBackToMain} className="p-2 hover:bg-white/20 rounded-full transition-colors mr-3" data-id="element-3716" data-mp="m54jmekcanb3">
            <ArrowLeftIcon className="w-5 h-5" data-id="element-3717" data-mp="c6p1v277cqe9" />
          </button>}
        <h3 className="text-xl font-bold" data-id="element-3718" data-mp="c8t4lgtd7jcy">{title}</h3>
      </div>
      <button onClick={handleClose} className="p-2 hover:bg-white/20 rounded-full transition-colors" data-id="element-3719" data-mp="h48ejxo94v43">
        <XIcon className="w-5 h-5" data-id="element-3720" data-mp="2wyqxvq5uaiiy" />
      </button>
    </div>;
  const renderContent = () => {
    switch (step) {
      case 'currentLocation':
        return <>
            <ModalHeader title="Confirm Your Location" showBack data-id="element-3721" data-mp="2ht4jujfxkly8" />
            <div className="relative bg-gray-200 h-64 flex-shrink-0 md:h-80" data-id="element-3722" data-mp="2drsv0g4vs4r3">
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-3723" data-mp="2912qf54a45xg">
                <div className="text-center" data-id="element-3724" data-mp="2429al61is2u4">
                  <MapPinIcon className="w-12 h-12 text-[#0066CC] mx-auto mb-2" data-id="element-3725" data-mp="2416hqskmzqbk" />
                  <p className="text-sm text-gray-600 font-medium" data-id="element-3726" data-mp="1z3euibuxssdp">Map View</p>
                  <p className="text-xs text-gray-500 mt-1" data-id="element-3727" data-mp="1u4bn4krhia2k">
                    Lat: {detectedLocation.lat}, Lng: {detectedLocation.lng}
                  </p>
                </div>
              </div>
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-full" data-id="element-3728" data-mp="1l3n7xmqcu3o3">
                <MapPinIcon className="w-8 h-8 text-red-500 drop-shadow-lg" data-id="element-3729" data-mp="3kg7tia8bo6hl" />
              </div>
            </div>
            <div className="p-6 flex-1 overflow-y-auto" data-id="element-3730" data-mp="3fh4yzjpyxinv">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3731" data-mp="3ffk4fu3nlzq0">
                Detected Address
              </label>
              <textarea value={gpsAddress} onChange={e => setGpsAddress(e.target.value)} className="w-full border border-gray-300 rounded-lg py-3 px-4 focus:outline-none focus:ring-2 focus:ring-[#0066CC] focus:border-transparent resize-none" rows={3} data-id="element-3732" data-mp="3rzh1bz16jx4j" />
              <p className="text-xs text-gray-500 mt-2" data-id="element-3733" data-mp="343mhoiglrzyu">
                You can edit the address if needed
              </p>
            </div>
            <div className="p-6 border-t border-gray-200 flex gap-3 flex-shrink-0" data-id="element-3734" data-mp="3e092x8cuct1e">
              <button onClick={handleBackToMain} className="flex-1 border-2 border-gray-300 text-gray-700 font-medium py-3 px-4 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-3735" data-mp="3e2lt28sr69pj">
                Back
              </button>
              <button onClick={handleSaveGPSLocation} className="flex-1 bg-[#0066CC] hover:bg-[#0052a3] text-white font-medium py-3 px-4 rounded-lg transition-colors" data-id="element-3736" data-mp="xaaozrvdp3qy">
                Save Location
              </button>
            </div>
          </>;
      case 'manual':
        return <>
            <ModalHeader title="Add Address Manually" showBack data-id="element-3737" data-mp="10tt06wc13k1g" />
            <div className="p-6 flex-1 overflow-y-auto" data-id="element-3738" data-mp="10vm80eydoab1">
              <div className="space-y-4" data-id="element-3739" data-mp="1es94kgmf4ygf">
                <div data-id="element-3740" data-mp="1er7uaed88fzr">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3741" data-mp="19uhbhja1f6an">
                    City *
                  </label>
                  <select value={manualCity} onChange={e => {
                  setManualCity(e.target.value);
                  setManualDistrict('');
                }} className="w-full border border-gray-300 rounded-lg py-3 px-4 focus:outline-none focus:ring-2 focus:ring-[#0066CC] focus:border-transparent" data-id="element-3742" data-mp="1oi2gxjudxhlq">
                    <option value="" data-id="element-3743" data-mp="2c7sgb4mwspnc">Select City</option>
                    {cities.map(city => <option key={city.id} value={city.id} data-id="element-3744" data-mp="2h4agrsb7i1tv">
                        {city.name}
                      </option>)}
                  </select>
                </div>
                <div data-id="element-3745" data-mp="283kouzp2gvlf">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3746" data-mp="28707udlv2os4">
                    District / Neighborhood *
                  </label>
                  <select value={manualDistrict} onChange={e => setManualDistrict(e.target.value)} disabled={!manualCity} className="w-full border border-gray-300 rounded-lg py-3 px-4 focus:outline-none focus:ring-2 focus:ring-[#0066CC] focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed" data-id="element-3747" data-mp="1y6zj2c583ggj">
                    <option value="" data-id="element-3748" data-mp="1fex18xguhu4p">Select District</option>
                    {manualCity && districtsByCity[manualCity]?.map(district => <option key={district} value={district} data-id="element-3749" data-mp="3ce5o2k0064f7">
                          {district}
                        </option>)}
                  </select>
                </div>
                <div data-id="element-3750" data-mp="33esdtp421btf">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3751" data-mp="33fahh6t1qsbd">
                    Street / Building / Additional Details *
                  </label>
                  <textarea value={manualDetails} onChange={e => setManualDetails(e.target.value)} placeholder="Street name, building number, floor, apartment..." className="w-full border border-gray-300 rounded-lg py-3 px-4 focus:outline-none focus:ring-2 focus:ring-[#0066CC] focus:border-transparent resize-none" rows={4} data-id="element-3752" data-mp="3w253471lnxqf" />
                </div>
              </div>
            </div>
            <div className="p-6 border-t border-gray-200 flex-shrink-0" data-id="element-3753" data-mp="20m6dma3fo7qb">
              <button onClick={handleSaveManualAddress} className="w-full bg-[#0066CC] hover:bg-[#0052a3] text-white font-medium py-3 px-4 rounded-lg transition-colors" data-id="element-3754" data-mp="25khomo5gsoa4">
                Save Location
              </button>
            </div>
          </>;
      case 'national':
        return <>
            <ModalHeader title="Use National Address" showBack data-id="element-3755" data-mp="2jbmrs081jyp7" />
            <div className="p-6 flex-1 overflow-y-auto" data-id="element-3756" data-mp="2oa6ei2ugleim">
              <div className="space-y-4" data-id="element-3757" data-mp="2ocso080wu43h">
                <div data-id="element-3758" data-mp="2t9sp04iwkgnq">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3759" data-mp="2talruueqqm0l">
                    National Address ID
                  </label>
                  <input type="text" value={nationalAddressId} onChange={e => setNationalAddressId(e.target.value)} placeholder="1234-5678-9101" className="w-full border border-gray-300 rounded-lg py-3 px-4 focus:outline-none focus:ring-2 focus:ring-[#0066CC] focus:border-transparent" data-id="element-3760" data-mp="ywb0ae6rhdr4" />
                  <p className="text-xs text-gray-500 mt-2" data-id="element-3761" data-mp="3fizk871v8syt">
                    Enter your Saudi National Address ID
                  </p>
                </div>
                <button onClick={handleGetNationalAddress} className="w-full py-3 px-4 border-2 border-[#0066CC] text-[#0066CC] font-medium rounded-lg hover:bg-blue-50 transition-colors" data-id="element-3762" data-mp="3alhip1q6hg0u">
                  Get Details
                </button>
                {nationalAddressDetails && <div className="bg-gray-50 border border-gray-200 rounded-lg p-4" data-id="element-3763" data-mp="2rsdkd320mezw">
                    <h4 className="font-semibold text-gray-900 mb-3" data-id="element-3764" data-mp="b3zsenssx0bp">
                      Address Details
                    </h4>
                    <div className="space-y-2 text-sm" data-id="element-3765" data-mp="71mp061j1ei3">
                      <div className="flex justify-between py-2 border-b border-gray-200" data-id="element-3766" data-mp="em6ztsg0a8v3">
                        <span className="text-gray-600" data-id="element-3767" data-mp="jla59dzweh3l">City:</span>
                        <span className="font-medium text-gray-900" data-id="element-3768" data-mp="jmuwouqx1jx8">
                          {nationalAddressDetails.city}
                        </span>
                      </div>
                      <div className="flex justify-between py-2 border-b border-gray-200" data-id="element-3769" data-mp="9nvofda2bqar">
                        <span className="text-gray-600" data-id="element-3770" data-mp="xdq19uudtev0">District:</span>
                        <span className="font-medium text-gray-900" data-id="element-3771" data-mp="12bi0zb19q59r">
                          {nationalAddressDetails.district}
                        </span>
                      </div>
                      <div className="flex justify-between py-2 border-b border-gray-200" data-id="element-3772" data-mp="slyiw7ldqffy">
                        <span className="text-gray-600" data-id="element-3773" data-mp="1gbj46x509ose">Street:</span>
                        <span className="font-medium text-gray-900" data-id="element-3774" data-mp="1ga80exbk8h1a">
                          {nationalAddressDetails.street}
                        </span>
                      </div>
                      <div className="flex justify-between py-2 border-b border-gray-200" data-id="element-3775" data-mp="3cooi5bj1k2t2">
                        <span className="text-gray-600" data-id="element-3776" data-mp="3hl56o6u5kj6o">Building No.:</span>
                        <span className="font-medium text-gray-900" data-id="element-3777" data-mp="32y2b45pe4klz">
                          {nationalAddressDetails.buildingNo}
                        </span>
                      </div>
                      <div className="flex justify-between py-2 border-b border-gray-200" data-id="element-3778" data-mp="2tx42fa40box2">
                        <span className="text-gray-600" data-id="element-3779" data-mp="2xy7j1ytvpozc">Postal Code:</span>
                        <span className="font-medium text-gray-900" data-id="element-3780" data-mp="2xwcxcias9su7">
                          {nationalAddressDetails.postalCode}
                        </span>
                      </div>
                      <div className="flex justify-between py-2" data-id="element-3781" data-mp="2oy18olth954e">
                        <span className="text-gray-600" data-id="element-3782" data-mp="i8cxtx4c56ve">Additional Info:</span>
                        <span className="font-medium text-gray-900" data-id="element-3783" data-mp="n6xw3r011gh7">
                          {nationalAddressDetails.additionalInfo}
                        </span>
                      </div>
                    </div>
                  </div>}
              </div>
            </div>
            {nationalAddressDetails && <div className="p-6 border-t border-gray-200 flex-shrink-0" data-id="element-3784" data-mp="2hftcb2ljs2zp">
                <button onClick={handleSaveNationalAddress} className="w-full bg-[#0066CC] hover:bg-[#0052a3] text-white font-medium py-3 px-4 rounded-lg transition-colors" data-id="element-3785" data-mp="2cna12cac1jy2">
                  Save Location
                </button>
              </div>}
          </>;
      default:
        return <>
            <ModalHeader title="Select Delivery Address" data-id="element-3786" data-mp="2vdhyqev9ji6v" />
            <div className="p-6 overflow-y-auto flex-1" data-id="element-3787" data-mp="2vbyekd6hkmzt">
              {deliveryType === 'delivery' ? <>
                  <div className="space-y-3 mb-6" data-id="element-3788" data-mp="1109yu8sfkged">
                    <button onClick={() => handleNavigateToStep('currentLocation')} className="w-full flex items-center p-4 border border-gray-200 rounded-xl hover:border-[#0066CC] hover:bg-blue-50 transition-all group" data-id="element-3789" data-mp="111l1u6e1xk4f">
                      <div className="flex-shrink-0 w-10 h-10 bg-blue-50 rounded-lg flex items-center justify-center mr-4 group-hover:bg-blue-100 transition-colors" data-id="element-3790" data-mp="1zo2gxvf1b8ms">
                        <NavigationIcon className="w-5 h-5 text-[#0066CC]" data-id="element-3791" data-mp="29njji3yzp6ej" />
                      </div>
                      <div className="text-left flex-1" data-id="element-3792" data-mp="2do3jdfay6o4d">
                        <div className="font-bold text-gray-900" data-id="element-3793" data-mp="2dmik5cdouh06">
                          Use My Current Location
                        </div>
                        <div className="text-xs text-gray-500 mt-0.5" data-id="element-3794" data-mp="2neodapfof4gy">
                          Enable location services
                        </div>
                      </div>
                      <ChevronRightIcon className="w-5 h-5 text-gray-400 group-hover:text-[#0066CC] transition-colors" data-id="element-3795" data-mp="2xcci686zxscu" />
                    </button>
                    <button onClick={() => handleNavigateToStep('manual')} className="w-full flex items-center p-4 border border-gray-200 rounded-xl hover:border-[#0066CC] hover:bg-blue-50 transition-all group" data-id="element-3796" data-mp="lqtugn4rgijf">
                      <div className="flex-shrink-0 w-10 h-10 bg-green-50 rounded-lg flex items-center justify-center mr-4 group-hover:bg-green-100 transition-colors" data-id="element-3797" data-mp="6t1j8768ygb1">
                        <PencilIcon className="w-5 h-5 text-green-600" data-id="element-3798" data-mp="zgxcf1wlxq32" />
                      </div>
                      <div className="text-left flex-1" data-id="element-3799" data-mp="upnpwa6cv2ve">
                        <div className="font-bold text-gray-900" data-id="element-3800" data-mp="uo48gg8yqls1">
                          Enter Address Manually
                        </div>
                        <div className="text-xs text-gray-500 mt-0.5" data-id="element-3801" data-mp="1n5ygkcyeqf2j">
                          Fill in your address details
                        </div>
                      </div>
                      <ChevronRightIcon className="w-5 h-5 text-gray-400 group-hover:text-[#0066CC] transition-colors" data-id="element-3802" data-mp="12xi1ciabpd8z" />
                    </button>
                    <button onClick={() => handleNavigateToStep('national')} className="w-full flex items-center p-4 border border-gray-200 rounded-xl hover:border-[#0066CC] hover:bg-blue-50 transition-all group" data-id="element-3803" data-mp="17xctsq9qyaw5">
                      <div className="flex-shrink-0 w-10 h-10 bg-purple-50 rounded-lg flex items-center justify-center mr-4 group-hover:bg-purple-100 transition-colors" data-id="element-3804" data-mp="1lnq1qsmn1plh">
                        <MapIcon className="w-5 h-5 text-purple-600" data-id="element-3805" data-mp="1by6fre3mpfme" />
                      </div>
                      <div className="text-left flex-1" data-id="element-3806" data-mp="1gx9l6znitnuw">
                        <div className="font-bold text-gray-900" data-id="element-3807" data-mp="1gvotriwi6l19">
                          Use National Address
                        </div>
                        <div className="text-xs text-gray-500 mt-0.5" data-id="element-3808" data-mp="29dkezbavdg69">
                          Enter your National Address ID
                        </div>
                      </div>
                      <ChevronRightIcon className="w-5 h-5 text-gray-400 group-hover:text-[#0066CC] transition-colors" data-id="element-3809" data-mp="3u1msgc4ewbiq" />
                    </button>
                  </div>
                  {savedAddresses.length > 0 && <div data-id="element-3810" data-mp="2pjwb5jj61fk">
                      <h3 className="text-sm font-semibold text-gray-700 mb-3" data-id="element-3811" data-mp="2qcz5vfdc6sf">
                        Saved Addresses
                      </h3>
                      <div className="space-y-3" data-id="element-3812" data-mp="3b6yahivh3byp">
                        {savedAddresses.map(address => {
                    const Icon = address.icon;
                    return <div key={address.id} className={`flex items-start p-3 border rounded-xl transition-all cursor-pointer ${selectedAddress?.id === address.id ? 'border-[#0066CC] bg-blue-50' : 'border-gray-200 hover:border-[#0066CC] hover:bg-blue-50'}`} onClick={() => setSelectedAddress(address)} data-id="element-3813" data-mp="3k3gsw162vhh1">
                              <div className="flex-shrink-0 w-8 h-8 bg-blue-50 rounded-lg flex items-center justify-center mr-3" data-id="element-3814" data-mp="3t710isaeteaz">
                                <Icon className="w-4 h-4 text-[#0066CC]" data-id="element-3815" data-mp="22kfbw1tdfgv" />
                              </div>
                              <div className="flex-1 min-w-0" data-id="element-3816" data-mp="62b6w1z5zzmg">
                                <div className="font-bold text-sm text-gray-900" data-id="element-3817" data-mp="35irb7gdzm8f3">
                                  {address.name}
                                </div>
                                <div className="text-xs text-gray-500 mt-0.5 line-clamp-1" data-id="element-3818" data-mp="3eio5pyn261i2">
                                  {address.address}
                                </div>
                              </div>
                              <div className="flex-shrink-0 flex gap-1 ml-2" data-id="element-3819" data-mp="2ms03skdk8s3c">
                                <button onClick={e => {
                          e.stopPropagation();
                          handleEditAddress(address);
                        }} className="p-1.5 text-gray-400 hover:text-[#0066CC] hover:bg-blue-100 rounded-lg transition-colors" data-id="element-3820" data-mp="2qt26xcalloal">
                                  <PencilIcon className="w-3.5 h-3.5" data-id="element-3821" data-mp="25ab2ily7dg3q" />
                                </button>
                                <button onClick={e => {
                          e.stopPropagation();
                          handleRemoveAddress(address.id);
                        }} className="p-1.5 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors" data-id="element-3822" data-mp="20aygg3f5od27">
                                  <TrashIcon className="w-3.5 h-3.5" data-id="element-3823" data-mp="1hivwoj77wgnq" />
                                </button>
                              </div>
                            </div>;
                  })}
                      </div>
                    </div>}
                </> : <>
                  <div className="bg-gray-50 border border-gray-200 rounded-xl p-5 mb-6" data-id="element-3824" data-mp="2rhdt4weqb975">
                    <h3 className="text-sm font-semibold text-gray-700 mb-4" data-id="element-3825" data-mp="2wg6whw0axjtl">
                      Filter Branches
                    </h3>
                    <div className="space-y-4" data-id="element-3826" data-mp="2hq9cztdbhiaq">
                      <div data-id="element-3827" data-mp="2hphmgwykuarb">
                        <label className="block text-xs font-medium text-gray-600 mb-2" data-id="element-3828" data-mp="2mikciv45b22r">
                          City *
                        </label>
                        <select value={pickupCity} onChange={e => {
                      setPickupCity(e.target.value);
                      setPickupDistrict('');
                    }} className="w-full border border-gray-300 rounded-lg py-2.5 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#0066CC] focus:border-transparent" data-id="element-3829" data-mp="28oje62h3vh2x">
                          <option value="" data-id="element-3830" data-mp="1f7pw6hlynk1t">All Cities</option>
                          {cities.map(city => <option key={city.id} value={city.id} data-id="element-3831" data-mp="1u5ibb8nli6fh">
                              {city.name}
                            </option>)}
                        </select>
                      </div>
                      <div data-id="element-3832" data-mp="23293h9z1114s">
                        <label className="block text-xs font-medium text-gray-600 mb-2" data-id="element-3833" data-mp="1y627oa0ch60k">
                          District / Neighborhood
                        </label>
                        <select value={pickupDistrict} onChange={e => setPickupDistrict(e.target.value)} disabled={!pickupCity} className="w-full border border-gray-300 rounded-lg py-2.5 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#0066CC] focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed" data-id="element-3834" data-mp="2cw9iq4o0vmr8">
                          <option value="" data-id="element-3835" data-mp="3e9n0l4njga3w">All Districts</option>
                          {pickupCity && districtsByCity[pickupCity]?.map(district => <option key={district} value={district} data-id="element-3836" data-mp="357dtypve50vs">
                                {district}
                              </option>)}
                        </select>
                      </div>
                      <div className="flex items-center justify-between pt-2" data-id="element-3837" data-mp="2vgj7bke8fz9t">
                        <label className="text-sm font-medium text-gray-700" data-id="element-3838" data-mp="2qjsowqeygrl8">
                          Show Nearest Branches
                        </label>
                        <button onClick={() => setShowNearest(!showNearest)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${showNearest ? 'bg-[#0066CC]' : 'bg-gray-300'}`} data-id="element-3839" data-mp="2hjcqhvd2kan8">
                          <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${showNearest ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-3840" data-mp="x0akbgc1lv6v" />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="mb-6" data-id="element-3841" data-mp="9ciud9xkxjn4">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3842" data-mp="dct1wr10si43">
                      Search Pharmacy
                    </label>
                    <div className="relative" data-id="element-3843" data-mp="ib4cj3z52wnd">
                      <input type="text" placeholder="Search by area or pharmacy name" className="w-full border border-gray-300 rounded-lg py-3 pl-10 pr-4 focus:outline-none focus:ring-2 focus:ring-[#0066CC] focus:border-transparent" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-3844" data-mp="n2mcpptc8t7a" />
                      <SearchIcon className="w-5 h-5 text-gray-400 absolute left-3 top-1/2 transform -translate-y-1/2" data-id="element-3845" data-mp="sx31ruxplc8j" />
                    </div>
                  </div>
                  <div data-id="element-3846" data-mp="12o7fkrbner1s">
                    <h3 className="text-sm font-semibold text-gray-700 mb-3" data-id="element-3847" data-mp="12p0j7jfb90fp">
                      {showNearest ? 'Nearest Pharmacies' : 'Available Pharmacies'}{' '}
                      ({getFilteredBranches().length})
                    </h3>
                    <div className="space-y-3" data-id="element-3848" data-mp="o04bjnh61pfm">
                      {getFilteredBranches().length > 0 ? getFilteredBranches().map(pharmacy => <button key={pharmacy.id} onClick={() => {
                    setSelectedPickupBranch(pharmacy);
                  }} className={`w-full flex items-start p-3 border rounded-xl transition-all text-left ${selectedPickupBranch?.id === pharmacy.id ? 'border-[#0066CC] bg-blue-50' : 'border-gray-200 hover:border-[#0066CC] hover:bg-blue-50'}`} data-id="element-3849" data-mp="1zdoxc4nwo3ju">
                            <div className="flex-shrink-0 w-8 h-8 bg-green-50 rounded-lg flex items-center justify-center mr-3" data-id="element-3850" data-mp="1xwj7rvqiyomx">
                              <StoreIcon className="w-4 h-4 text-green-600" data-id="element-3851" data-mp="2lnydzzlf9q3g" />
                            </div>
                            <div className="flex-1" data-id="element-3852" data-mp="2ql6yw7xyg88e">
                              <div className="font-bold text-sm text-gray-900" data-id="element-3853" data-mp="2bx3uh2zk94lp">
                                {pharmacy.name}
                              </div>
                              <div className="text-xs text-gray-500 mt-0.5 line-clamp-1" data-id="element-3854" data-mp="2gtu6nf88vg1u">
                                {pharmacy.address}
                              </div>
                              <div className="flex items-center gap-3 mt-1.5" data-id="element-3855" data-mp="39dspodu098m4">
                                <span className="text-[10px] text-[#0066CC] font-bold bg-blue-50 px-1.5 py-0.5 rounded" data-id="element-3856" data-mp="1krg9h9qgrm1r">
                                  {pharmacy.distance} km
                                </span>
                                <span className="text-[10px] text-green-600 font-bold bg-green-50 px-1.5 py-0.5 rounded" data-id="element-3857" data-mp="1bq8otugvejq5">
                                  {pharmacy.hours}
                                </span>
                              </div>
                            </div>
                          </button>) : <div className="text-center py-8 text-gray-500" data-id="element-3858" data-mp="1uo1j68dfhlbx">
                          <StoreIcon className="w-12 h-12 mx-auto mb-3 text-gray-400" data-id="element-3859" data-mp="1pphtpxzmlret" />
                          <p className="text-sm" data-id="element-3860" data-mp="1pnnhr96c19mv">
                            No pharmacies found matching your filters
                          </p>
                          <p className="text-xs mt-1" data-id="element-3861" data-mp="2id471xynoaev">
                            Try adjusting your search criteria
                          </p>
                        </div>}
                    </div>
                  </div>
                </>}
            </div>
            <div className="p-6 border-t border-gray-200 flex-shrink-0" data-id="element-3862" data-mp="2zmg6pjmwf8yk">
              <button onClick={handleConfirmAddress} disabled={!selectedAddress} className="w-full bg-[#0066CC] hover:bg-[#0052a3] text-white font-medium py-3 px-4 rounded-lg transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed" data-id="element-3863" data-mp="34mb13x5vugod">
                Confirm Address
              </button>
            </div>
          </>;
    }
  };
  useEffect(() => {
    if (initialAddress) {
      setManualCity(initialAddress.city || '');
      setManualDistrict(initialAddress.district || '');
      setManualDetails(initialAddress.street || '');
      setNationalAddressId(initialAddress.nationalAddressId || '');
    }
  }, [initialAddress]);
  if (!isOpen) return null;
  return <>
      <div className="fixed inset-0 bg-black bg-opacity-45 z-[200] transition-opacity duration-300" onClick={handleClose} data-id="element-3864" data-mp="1x9ia6gkogioz"></div>
      <div className="fixed inset-0 z-[201] flex items-end md:items-center justify-center md:p-12" data-id="element-3865" data-mp="2612850hhqoiw">
        <div className="bg-white w-full md:w-[600px] lg:w-[650px] max-h-[90vh] md:max-h-[calc(100vh-96px)] overflow-hidden flex flex-col animate-slide-up md:animate-none md:rounded-xl shadow-2xl" style={{
        borderTopLeftRadius: '16px',
        borderTopRightRadius: '16px'
      }} onClick={e => e.stopPropagation()} data-id="element-3866" data-mp="21a28vokwfud8">
          {renderContent()}
        </div>
      </div>
      {isNowCoverageUnavailable && <div className="fixed inset-0 z-[210] flex items-end bg-black/45 md:items-center md:justify-center md:p-4" role="dialog" aria-modal="true" aria-labelledby="coverage-title" data-id="element-3867" data-mp="2kwgq9d4vxomd"><button type="button" className="absolute inset-0" onClick={() => setIsNowCoverageUnavailable(false)} aria-label="Close coverage notice" data-id="element-3868" data-mp="qlv8g0mkkkqc" /><section className="relative w-full rounded-t-3xl bg-white p-5 pb-[calc(env(safe-area-inset-bottom)+20px)] md:max-w-md md:rounded-2xl" data-id="element-3869" data-mp="gize67dffc89"><div className="mx-auto h-1 w-10 rounded-full bg-gray-300 md:hidden" data-id="element-3870" data-mp="6rbtcpbdktfr" /><span className="mt-4 flex h-11 w-11 items-center justify-center rounded-xl bg-amber-50 text-amber-700" data-id="element-3871" data-mp="6oz9u7pyyb0l"><MapPinIcon className="h-5 w-5" data-id="element-3872" data-mp="3sy08lnmhr5mo" /></span><h2 id="coverage-title" className="mt-4 text-xl font-bold text-gray-900" data-id="element-3873" data-mp="3swyx5i1kch4f">NOW is not available here yet</h2><p className="mt-2 text-sm leading-6 text-gray-600" data-id="element-3874" data-mp="1sid4p4peobw">We can still deliver to this address with standard delivery. Choose another address to check fast delivery coverage.</p><div className="mt-5 grid gap-3" data-id="element-3875" data-mp="3ovwv6tg9hqyr"><button type="button" onClick={() => setIsNowCoverageUnavailable(false)} className="h-11 rounded-xl border border-gray-300 text-sm font-bold text-gray-700" data-id="element-3876" data-mp="3ox81azx6jat1">Choose another address</button><button type="button" onClick={continueWithStandardDelivery} className="h-11 rounded-xl bg-[#16726c] text-sm font-bold text-white" data-id="element-3877" data-mp="1n40l7o9qsp63">Continue with standard delivery</button></div></section></div>}
    </>;
}